import { useIntl } from "react-intl";

import { trackingShape, withTracking } from "../../context";
import { withUser } from "../../wrappers";
import { userShape } from "../../shapes";
import { htmlLink } from "../../utils";
import NavigationBanner from "./NavigationBanner";

type Props = {
  user: userShape;
  tracking: trackingShape;
};

function NavigationPermissionRequestsBanner({ user, tracking }: Props) {
  const intl = useIntl();
  const message = intl.formatMessage(
    { id: "root.open_permission_requests" },
    { a: htmlLink({ href: "/app/id/permission_requests" }) },
  );
  tracking?.trackEvent("PermissionRequest-NavigationBanner-seen");

  return user.openPermissionRequests ? (
    // @ts-expect-error TS(2322) FIXME: Type 'ReactNode' is not assignable to type 'string... Remove this comment to see the full error message
    <NavigationBanner id="open-permission-banner" message={message} />
  ) : null;
}

export default withUser(withTracking(NavigationPermissionRequestsBanner));
